import { InvoicePaymentDto } from 'src/app/revenue/shared/invoice-payment/dto/invoice-payment.dto';
import { PaymentTypeDto } from 'src/app/revenue/shared/payment-types/dto/payment-type.dto';
import { PaymentSource } from 'src/app/revenue/shared/payment-source/payment-source.model';

export interface PaymentHeaderDto {
  PaymentHeaderID: number;
  ProfileID: number;
  PaymentDate: Date;
  ApplyDate: Date;
  PaymentTypeID: number;
  Amount: number;
  Refno: string;
  CheckNum: string;
  Notes: string;
  DateCreated: Date;
  DateChanged: Date;
  ChangedBy: string;
  Posted: boolean;
  DatePosted: Date;
  Batch_Creation: string;
  Batch_Posting: string;
  PaymentType: string;
  PaymentSource: string;
  CC_CreditCardNum: string;
  CC_ValidThrough: string;
  CC_NameOnCard: string;
  CC_BillingAddress1: string;
  CC_BillingAddress2: string;
  CC_BillingCity: string;
  CC_BillingState: string;
  CC_BillingZip: string;
  CC_BillingZipExt: string;
  CC_PIN: string;
  CC_PhoneNum: string;
  CC_TypeOfCard: string;
  PostedBy: string;
  Dirty: boolean;

  _paymentType: PaymentTypeDto;
  _paymentSource: PaymentSource;
}

export function initializedPaymentHeaderDto() {
  const today = new Date();
  return {
    ProfileID: 0,
    PaymentDate: today,
    ApplyDate: today,
    PaymentTypeID: 0,
    Amount: 0,
    DateCreated: today,
    DateChanged: today,
    Posted: false,
    DatePosted: today,

    _paymentType: null,
    _paymentSource: null,
  } as PaymentHeaderDto;
}
